function limitedText30(text) {
	if (text) {
		return text.length > 30 ? text.slice(0, 30) + '…' : text
	} else {
		return text
	}
}

function limitedText50(text) {
	if (text) {
		return text.length > 50 ? text.slice(0, 50) + '…' : text
	} else {
		return text
	}
}

export { limitedText30, limitedText50 }
